import { RESET } from '../actionTypes';
import { loadAndWindModalActons } from '../reducer';

export default () => loadAndWindModalActons[RESET]();
